import React, { lazy, Suspense } from 'react';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import PropTypes from 'prop-types';
import './OfflineBooks.scss';
import '../ResourceContainer/ResourceContainer.scss';

const OfflineInfo = navigator.onLine
    ? lazy(() => import('./components/OfflineInfo'))
    : require('./components/OfflineInfo').default;

const OfflineText = navigator.onLine
    ? lazy(() => import('./components/OfflineText'))
    : require('./components/OfflineText').default;

const OfflineBooks = ({
    books,
    online,
    myLanguage,
    t,
    viewport,
    onDelete,
    checkedValues,
}) => {
    const baseClassName = 'pb-offline-books';

    const classes = {
        [baseClassName]: true,
        [`${baseClassName}--offline`]: !online,
    };

    return (
        <div className={classNames(classes)}>
            <Suspense fallback={<div />}>
                <OfflineInfo
                    t={t}
                    books={books}
                    baseClassName={baseClassName}
                    myLanguage={myLanguage}
                    online={online}
                />
            </Suspense>
            <Suspense fallback={<div />}>
                <OfflineText t={t} online={online} books={books} />
            </Suspense>
        </div>
    );
};

OfflineBooks.propTypes = {
    books: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            likesCount: PropTypes.number,
            is_favourite: PropTypes.bool,
        })
    ).isRequired,
    online: PropTypes.bool.isRequired,
    myLanguage: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    viewport: PropTypes.string,
    onDelete: PropTypes.func,
    checkedValues: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
};

export default translate()(OfflineBooks);
